/**
 * Darkens a hex color by reducing RGB components by 15%
 * @param {string} hex - The hex color code (e.g. '#RRGGBB')
 * @returns {string} Darkened hex color
 */
export const darkenColor = (hex) => {
  // Remove the # if present
  hex = hex.replace('#', '');
  
  // Convert to RGB
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);
  
  // Darken by reducing each component by 15%
  r = Math.floor(r * 0.85);
  g = Math.floor(g * 0.85);
  b = Math.floor(b * 0.85);
  
  // Convert back to hex
  return '#' + [r, g, b].map(x => {
    const hex = x.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  }).join('');
};

/**
 * Calculates the relative luminance of a hex color
 * @param {string} hex - The hex color code (e.g. '#RRGGBB')
 * @returns {number} Luminance value between 0 and 1
 */
export const getLuminance = (hex) => {
  // Remove the # if present
  hex = hex.replace('#', '');
  
  // Convert hex to RGB
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;
  
  // Calculate luminance using relative luminance formula
  // Using sRGB coefficients
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}; 